// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleListV2_container__VctSz"};